import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const PatientCardStyles: ComponentStylesWithFns = {
  cardLabel: {
    fontSize: '10px',
    fontWeight: 700,
    color: '#a0aab9',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    marginBottom: '10px',
  },

  patientCard: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    padding: '16px',
    flexShrink: 0,
  },
  patientName: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#111',
    marginTop: '4px',
  },
  patientMeta: {
    fontSize: '11px',
    color: '#a0aab9',
    marginTop: '4px',
  },
};
